// import React from 'react'
// import { Carousel } from 'react-bootstrap';
// import Header from '../../Header/Header';
// import TopNavbar from '../TopNavbar'
// import Footer from '../../Footer/Footer'
// import banner11 from '../img/banner11.png'
// import { Container, Row, Col, Card } from 'react-bootstrap';
// import main from '../img/main.jpg'
// import melvinjones from '../img/melvinjones.jpg'
// import symbol from '../img/symbol.png'
// import inv from '../img/tonybenbow.png'
// import ManojShah from '../img/ManojShah.jpeg'
// import singhap from '../img/singhap.jpg'
// import mark from '../img/lyon-mark.png'

// function International() {
//   return (
//     <div>
//       <Header />
//       <TopNavbar />

//       <div className="banner-area">
//         <Carousel id="bootcarousel" className="text-light heading-uppercase animate_text" controls indicators={false}>
//           <Carousel.Item className="bg-cover img-fluid active">
//             {/* <img src={banner10} className="d-block w-100" alt="First slide" /> */}
//           </Carousel.Item>
//           <Carousel.Item className="bg-cover img-fluid" style={{ padding: "30px" }}>
//             <img src={banner11} className="d-block w-100" alt="Second slide" />
//           </Carousel.Item>
//         </Carousel>
//       </div><br></br>

//       <section id="about-us" className="about-us">
//         <Container data-aos="fade-up">
//           <div className="section-title">
//             <h2>STORY BEGINS</h2>
//           </div><br></br>
//           <Row className="content">
//             <Col lg={6} data-aos="fade-right">
//               <img src={main} alt="Main" height='100%' width='80%' />
//             </Col>
//             <Col lg={6} md={6} className="pt-4 pt-lg-0" data-aos="fade-left">
//               <p style={{ color: "black", marginBottom: "250px", textAlign: "start" }}>
//                 In 1917, Melvin Jones, a 38-year-old Chicago business leader, told members of his local business club they should reach beyond business issues and address the betterment of their communities and the world. Jones' group, the Business Circle of Chicago, agreed.
//                 After contacting similar groups around the United States, an organizational meeting was held on June 7, 1917, in Chicago, Illinois, USA. The new group took the name of one of the invited groups, the "Association of Lions Clubs," and a national convention was held in Dallas, Texas, USA in October of that year. A constitution, by-laws, objects and a code of ethics were approved.
//                 Within three years, Lions became an international organization. Since then, we've earned high marks for both integrity and transparency. We're a well-run organization with a steady vision, a clear mission, and a long – and proud – history.
//               </p>
//             </Col>
//           </Row>
//         </Container>
//       </section><br></br>
//       <Container data-aos="fade-up">
//         <div className="section-title">
//           <h2>OUR MOTOS</h2>
//         </div><br></br>
//         <Row>
//           <Col lg={4} md={6} className="d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
//             <div className="icon-box iconbox-blue">
//               <div className="icon">
//                 <img src={melvinjones} style={{ width: '100%' }} alt="Melvin Jones" />
//               </div>
//               <h4> Our Founder</h4>
//               <p style={{ color: "black" }}><b>In 1917, Melvin Jones, a 38-year-old Chicago business leader, told members of his local</b></p>
//             </div>
//           </Col>

//           <Col lg={4} md={6} className="d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
//             <div className="icon-box iconbox-orange">
//               <div className="icon">
//                 <img src={symbol} style={{ width: '100%' }} alt="Vision" />
//               </div>
//               <h4>Our Vision</h4>
//               <p style={{ color: "black" }}><b>To be the global leader in community and humanitarian </b></p>
//             </div>
//           </Col>

//           <Col lg={4} md={6} className="d-flex align-items-stretch mt-4 mt-lg-0" data-aos="zoom-in" data-aos-delay="300">
//             <div className="icon-box iconbox-pink">
//               <div className="icon">
//                 <img src={symbol} style={{ width: '100%' }} alt="Mission" />
//               </div>
//               <h4>Our MISSION</h4>
//               <p style={{ color: "black" }}><b>To empower volunteers to serve their communities meet humanitarian needs, encourage peace and promote international understanding through Lions clubs</b></p>
//             </div>
//           </Col>

//           {/* <Col lg={4} md={6} className="d-flex align-items-stretch mt-4-lg-0" data-aos="zoom-in" data-aos-delay="200">
//             <div className="icon-box iconbox-red">
//               <div className="icon">
//                 <a href="assets/img/presidentialtheme.pdf"><img src={Oliveira} style={{ width: '100%' }} alt="A Heart for Service" /></a>
//               </div>
//               <h4>A HEART FOR SERVICE</h4>
//               <p style={{ color: "black" }}><b>Moving membership forward increasing leadership development, Promoting the fellowship of Lions</b></p>
//             </div>
//           </Col> */}
//         </Row>
//       </Container>
//       <br></br>
//       <section data-aos="fade-up">
//         <Container>
//           <div className="section-title">
//             <h2 >OUR TEAM</h2>
//           </div>
//           <Row className="no-gutters clients-wrap clearfix">
//             <Col lg={3} md={6} style={{ padding: '2%' }}>
//               <Card>
//                 <Card.Img src={singhap} height="270px" style={{ padding: '3% 1% 1% 2%' }} />
//                 <Card.Body>
//                   <Card.Title style={{ textAlign: 'center' }}>
//                     <a href="assets/img/bio-sheehan.pdf" style={{ color: '#000000' }}>A.P. singh</a>
//                   </Card.Title>
//                   <Card.Text style={{ color: "black" }}>President</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col lg={3} md={6} style={{ padding: '2%' }}>
//               <Card>
//                 <Card.Img src={mark} height="270px" style={{ padding: '3% 1% 0% 2%' }} />
//                 <Card.Body>
//                   <Card.Title style={{ textAlign: 'center' }}>
//                     <a href="assets/img/singh.jpg" style={{ color: '#000000' }}>Mark S. Layon</a>
//                   </Card.Title>
//                   <Card.Text style={{ color: "black" }}>First Vice President</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col lg={3} md={6} sm={1} style={{ padding: '2%' }}>
//               <Card>
//                 <Card.Img src={ManojShah} height="270px" style={{ padding: '3% 1% 0% 2%' }} />
//                 <Card.Body>
//                   <Card.Title style={{ textAlign: 'center' }}>
//                     <a href="assets/img/layon-mark.png" style={{ color: '#000000' }}>Manoj Shah</a>
//                   </Card.Title>
//                   <Card.Text style={{ color: "black" }}>Second Vice President</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col lg={3} md={6} style={{ padding: '2%', }}>
//               <Card>
//                 <Card.Img src={inv} height="270px" style={{ padding: '3% 1% 1% 2%' }} />
//                 <Card.Body>
//                   <Card.Title style={{ textAlign: 'center' }}>
//                     <a href="assets/img/bio-townsend.pdf" style={{ color: '#000000' }}>Tony Benbow</a>
//                   </Card.Title>
//                   <Card.Text style={{ color: "black" }}>Third Vice President</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </section><br></br>
//       <Footer />
//     </div>
//   )
// }

// export default International;









import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import Footer from "../../Footer/Footer";
import TopNavbar from "../TopNavbar";

import main from "../img/main.jpg";
import melvinjones from "../img/melvinjones.jpg";
import symbol from "../img/symbol.png";


// ======================================================
// BREADCRUMB ITEM
// ======================================================

const BreadcrumbItem = ({ crumb, isFirst }) => {
  const [isHovered, setIsHovered] = useState(false);

  const linkStyle = {
    color: isHovered ? "#FFD500" : "inherit",
    textDecoration: "none",
    transition: "color 0.2s ease",
  };

  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.375rem",
      }}
    >
      {!isFirst && (
        <span style={{ color: "rgba(255,255,255,0.4)" }}>
          /
        </span>
      )}

      {crumb.to ? (
        <Link
          to={crumb.to}
          style={linkStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {crumb.label}
        </Link>
      ) : (
        <span style={{ color: "#ffffff" }}>
          {crumb.label}
        </span>
      )}
    </span>
  );
};


// ======================================================
// BREADCRUMB
// ======================================================

const Breadcrumb = ({ crumbs }) => {

  const navStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.375rem",
    fontSize: "0.75rem",
    color: "rgba(255,255,255,0.7)",
    fontWeight: "500",
  };

  return (
    <nav style={navStyle}>
      {crumbs.map((crumb, index) => (
        <BreadcrumbItem
          key={index}
          crumb={crumb}
          isFirst={index === 0}
        />
      ))}
    </nav>
  );
};


// ======================================================
// MAIN INTERNATIONAL COMPONENT
// ======================================================

export default function International() {

  // ==================================================
  // HOVER STATES
  // ==================================================

  const [hoveredCard, setHoveredCard] = useState(null);
  const [hoveredLeader, setHoveredLeader] = useState(null);
  const [isCtaHovered, setIsCtaHovered] = useState(false);


  // ==================================================
  // PROGRAM STATES
  // ==================================================

  const [programs, setPrograms] = useState([]);
  const [programsLoading, setProgramsLoading] = useState(true);
  const [programsError, setProgramsError] = useState(null);


  // ==================================================
  // TEAM STATES
  // ==================================================

  const [teamLeaders, setTeamLeaders] = useState([]);
  const [teamLoading, setTeamLoading] = useState(true);
  const [teamError, setTeamError] = useState(null);


  // ==================================================
  // API URLs
  // ==================================================

  const PROGRAMS_API =
    "https://api.lionsmd320.org/pages/api/internationalprograms";

  const TEAM_API =
    "https://api.lionsmd320.org/pages/api/ourteam";


  // ==================================================
  // FETCH INTERNATIONAL PROGRAMS
  // ==================================================

  const fetchPrograms = async () => {

    try {

      setProgramsLoading(true);
      setProgramsError(null);

      console.log("Fetching Programs...");

      const response = await fetch(PROGRAMS_API);

      console.log(
        "Programs API Status:",
        response.status
      );

      if (!response.ok) {
        throw new Error(
          `Programs API Error: ${response.status}`
        );
      }

      const data = await response.json();

      console.log(
        "Programs API Response:",
        data
      );

      // Backend response:
      //
      // {
      //    programs: [...]
      // }

      if (Array.isArray(data.programs)) {

        setPrograms(data.programs);

      } else {

        setPrograms([]);

        console.warn(
          "Programs array not found in API response"
        );
      }

    } catch (error) {

      console.error(
        "Programs fetch error:",
        error
      );

      setProgramsError(
        "Could not load international programs. Please try again later."
      );

    } finally {

      setProgramsLoading(false);
    }
  };


  // ==================================================
  // FETCH TEAM
  // ==================================================

  const fetchTeam = async () => {

    try {

      setTeamLoading(true);
      setTeamError(null);

      console.log("Fetching Team...");

      const response = await fetch(TEAM_API);

      console.log(
        "Team API Status:",
        response.status
      );

      if (!response.ok) {
        throw new Error(
          `Team API Error: ${response.status}`
        );
      }

      const data = await response.json();

      console.log(
        "Team API Response:",
        data
      );

      // Backend response:
      //
      // {
      //    leaders: [...],
      //    team: [...]
      // }
      //
      // We use team array.

      if (Array.isArray(data.team)) {

        setTeamLeaders(data.team);

      } else if (Array.isArray(data.leaders)) {

        // Fallback if team array doesn't exist
        setTeamLeaders(data.leaders);

      } else {

        setTeamLeaders([]);

        console.warn(
          "Team array not found in API response"
        );
      }

    } catch (error) {

      console.error(
        "Team fetch error:",
        error
      );

      setTeamError(
        "Could not load team members. Please try again later."
      );

    } finally {

      setTeamLoading(false);
    }
  };


  // ==================================================
  // LOAD API DATA
  // ==================================================

  useEffect(() => {

    fetchPrograms();
    fetchTeam();

  }, []);


  // ==================================================
  // CONTAINER STYLE
  // ==================================================

  const containerStyle = {
    maxWidth: "1280px",
    margin: "0 auto",
    paddingLeft: "1rem",
    paddingRight: "1rem",
  };


  // ==================================================
  // BADGE STYLE
  // ==================================================

  const spanBadgeStyle = {
    color: "#0067B1",
    fontSize: "0.75rem",
    fontWeight: "700",
    letterSpacing: "0.1em",
    textTransform: "uppercase",
    borderBottom: "2px solid #FFD500",
    paddingBottom: "0.25rem",
    display: "inline-block",
  };


  // ==================================================
  // RETURN
  // ==================================================

  return (
    <>
      <TopNavbar />

      <div
        style={{
          width: "100%",
          overflowX: "hidden",
          fontFamily: "sans-serif",
        }}
      >

        {/* ==================================================
                    PAGE HEADER
                ================================================== */}

        <div
          style={{
            backgroundColor: "#0067B1",
            paddingTop: "3rem",
            paddingBottom: "3rem",
          }}
        >
          <div style={containerStyle}>

            <Breadcrumb
              crumbs={[
                {
                  label: "Home",
                  to: "/",
                },
                {
                  label: "International",
                },
              ]}
            />

            <h1
              style={{
                fontSize: "36px",
                fontWeight: 800,
                color: "#ffffff",
                marginTop: "16px",
                textAlign: "left",
                marginLeft: 0,
                marginRight: 0,
              }}
            >
              International
            </h1>

            <p
              style={{
                color: "rgba(255,255,255,0.7)",
                marginTop: "0.5rem",
                fontSize: "1rem",
                maxWidth: "36rem",
              }}
            >
              MD 320's connection to Lions Clubs
              International — a global community of
              1.4 million members in 200+ countries.
            </p>

          </div>
        </div>


        {/* ==================================================
                    STORY & HISTORY
                ================================================== */}

        <section
          style={{
            padding: "4rem 0",
            backgroundColor: "#ffffff",
          }}
        >
          <div style={containerStyle}>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "3rem",
                alignItems: "center",
              }}
            >

              <div
                style={{
                  flex: "1 1 500px",
                }}
              >

                <span style={spanBadgeStyle}>
                  Story Begins
                </span>

                <h2
                  style={{
                    fontSize: "1.875rem",
                    fontWeight: "800",
                    color: "#0067B1",
                    marginTop: "1.25rem",
                    marginBottom: "1.5rem",
                    lineHeight: "1.25",
                  }}
                >
                  A Century of Service and Vision
                </h2>

                <p
                  style={{
                    color: "#4b5563",
                    lineHeight: "1.7",
                    marginBottom: "1rem",
                  }}
                >
                  In 1917, Melvin Jones, a 38-year-old
                  Chicago business leader, told members
                  of his local business club they should
                  reach beyond business issues and address
                  the betterment of their communities and
                  the world.
                </p>

                <p
                  style={{
                    color: "#4b5563",
                    lineHeight: "1.7",
                    marginBottom: "1rem",
                  }}
                >
                  The new group took the name of one of
                  the invited groups, the "Association
                  of Lions Clubs," and a national
                  convention was held in Dallas, Texas,
                  USA in October of that year.
                </p>

                <p
                  style={{
                    color: "#4b5563",
                    lineHeight: "1.7",
                  }}
                >
                  Since then, we've earned high marks
                  for both integrity and transparency.
                  We're a well-run organization with a
                  steady vision, a clear mission, and a
                  long and proud history.
                </p>

              </div>


              <div
                style={{
                  flex: "1 1 400px",
                }}
              >

                <div
                  style={{
                    borderRadius: "1rem",
                    overflow: "hidden",
                    boxShadow:
                      "0 10px 15px -3px rgba(0,0,0,0.1)",
                    border:
                      "1px solid #f3f4f6",
                  }}
                >
                  <img
                    src={main}
                    alt="Lions Club History"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>

              </div>

            </div>

          </div>
        </section>


        {/* ==================================================
                    FOUNDER / VISION / MISSION
                ================================================== */}

        <section
          style={{
            padding: "4rem 0",
            backgroundColor: "#f9fafb",
          }}
        >
          <div style={containerStyle}>

            <div
              style={{
                textAlign: "center",
                marginBottom: "3rem",
              }}
            >
              <span style={spanBadgeStyle}>
                Our Motos
              </span>

              <h2
                style={{
                  fontSize: "1.875rem",
                  fontWeight: "800",
                  color: "#0067B1",
                  marginTop: "1.25rem",
                }}
              >
                Founder, Vision & Mission
              </h2>
            </div>


            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "2rem",
              }}
            >

              {/* Founder */}

              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "0.75rem",
                  padding: "2rem",
                  border:
                    "1px solid #f3f4f6",
                  boxShadow:
                    "0 1px 2px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >

                <div
                  style={{
                    width: "6rem",
                    height: "6rem",
                    borderRadius: "9999px",
                    overflow: "hidden",
                    marginBottom: "1.5rem",
                    border:
                      "4px solid rgba(255,213,0,0.5)",
                  }}
                >

                  <img
                    src={melvinjones}
                    alt="Melvin Jones"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                </div>

                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "1.25rem",
                    color: "#0067B1",
                    marginBottom: "0.75rem",
                  }}
                >
                  Our Founder
                </h3>

                <p
                  style={{
                    color: "#4b5563",
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  }}
                >
                  In 1917, Melvin Jones, a 38-year-old
                  Chicago business leader, told members
                  of his local business club to reach
                  beyond business and address the
                  betterment of their communities.
                </p>

              </div>


              {/* Vision */}

              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "0.75rem",
                  padding: "2rem",
                  border:
                    "1px solid #f3f4f6",
                  boxShadow:
                    "0 1px 2px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >

                <div
                  style={{
                    width: "6rem",
                    height: "6rem",
                    borderRadius: "9999px",
                    overflow: "hidden",
                    marginBottom: "1.5rem",
                    border:
                      "4px solid rgba(255,213,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f0f7ff",
                  }}
                >

                  <img
                    src={symbol}
                    alt="Vision Symbol"
                    style={{
                      width: "3.5rem",
                      height: "3.5rem",
                      objectFit: "contain",
                    }}
                  />

                </div>

                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "1.25rem",
                    color: "#0067B1",
                    marginBottom: "0.75rem",
                  }}
                >
                  Our Vision
                </h3>

                <p
                  style={{
                    color: "#4b5563",
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  }}
                >
                  To be the global leader in community
                  and humanitarian service.
                </p>

              </div>


              {/* Mission */}

              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "0.75rem",
                  padding: "2rem",
                  border:
                    "1px solid #f3f4f6",
                  boxShadow:
                    "0 1px 2px rgba(0,0,0,0.05)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >

                <div
                  style={{
                    width: "6rem",
                    height: "6rem",
                    borderRadius: "9999px",
                    overflow: "hidden",
                    marginBottom: "1.5rem",
                    border:
                      "4px solid rgba(255,213,0,0.5)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#f0f7ff",
                  }}
                >

                  <img
                    src={symbol}
                    alt="Mission Symbol"
                    style={{
                      width: "3.5rem",
                      height: "3.5rem",
                      objectFit: "contain",
                    }}
                  />

                </div>

                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "1.25rem",
                    color: "#0067B1",
                    marginBottom: "0.75rem",
                  }}
                >
                  Our Mission
                </h3>

                <p
                  style={{
                    color: "#4b5563",
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  }}
                >
                  To empower volunteers to serve their
                  communities, meet humanitarian needs,
                  encourage peace and promote
                  international understanding through
                  Lions clubs.
                </p>

              </div>

            </div>

          </div>
        </section>


        {/* ==================================================
                    GLOBAL CONNECTION
                ================================================== */}

        <section
          style={{
            padding: "4rem 0",
            backgroundColor: "#ffffff",
          }}
        >
          <div style={containerStyle}>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "3rem",
                alignItems: "center",
              }}
            >

              <div
                style={{
                  flex: "1 1 500px",
                }}
              >

                <span style={spanBadgeStyle}>
                  Global Connection
                </span>

                <h2
                  style={{
                    fontSize: "1.875rem",
                    fontWeight: "800",
                    color: "#0067B1",
                    marginTop: "1.25rem",
                    marginBottom: "1.5rem",
                    lineHeight: "1.25",
                  }}
                >
                  Part of the World's Largest
                  <br />
                  Service Organization
                </h2>

                <p
                  style={{
                    color: "#4b5563",
                    lineHeight: "1.7",
                    marginBottom: "1.25rem",
                  }}
                >
                  As a multiple district within Lions
                  Clubs International (LCI), MD 320 is
                  part of a global network that mobilizes
                  volunteers to meet the most pressing
                  humanitarian needs of communities.
                </p>

                <p
                  style={{
                    color: "#4b5563",
                    lineHeight: "1.7",
                  }}
                >
                  The Lions Clubs International Foundation
                  (LCIF) supports our humanitarian work
                  with grants and matching funds that
                  amplify the impact of every service
                  project our clubs undertake.
                </p>

              </div>


              <div
                style={{
                  flex: "1 1 350px",
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(2,1fr)",
                  gap: "1rem",
                }}
              >

                {[
                  {
                    value: "1.4M+",
                    label: "Members Worldwide",
                  },
                  {
                    value: "200+",
                    label: "Countries",
                  },
                  {
                    value: "$1B+",
                    label: "LCIF Grants Awarded",
                  },
                  {
                    value: "107",
                    label: "Years of Service",
                  },
                ].map((stat) => (

                  <div
                    key={stat.label}
                    style={{
                      backgroundColor: "#f0f7ff",
                      border:
                        "1px solid #dceeff",
                      borderRadius: "0.75rem",
                      padding: "1.25rem",
                      textAlign: "center",
                    }}
                  >

                    <div
                      style={{
                        fontSize: "1.5rem",
                        fontWeight: "800",
                        color: "#0067B1",
                      }}
                    >
                      {stat.value}
                    </div>

                    <div
                      style={{
                        color: "#6b7280",
                        fontSize: "0.75rem",
                        marginTop: "0.25rem",
                      }}
                    >
                      {stat.label}
                    </div>

                  </div>

                ))}

              </div>

            </div>

          </div>
        </section>


        {/* ==================================================
                    OUR TEAM
                ================================================== */}

        <section
          style={{
            padding: "4rem 0",
            backgroundColor: "#f9fafb",
          }}
        >
          <div style={containerStyle}>

            <div
              style={{
                textAlign: "center",
                marginBottom: "3rem",
              }}
            >

              <span style={spanBadgeStyle}>
                Leadership
              </span>

              <h2
                style={{
                  fontSize: "1.875rem",
                  fontWeight: "800",
                  color: "#0067B1",
                  marginTop: "1.25rem",
                }}
              >
                Our Team
              </h2>

            </div>


            {/* TEAM LOADING */}

            {teamLoading && (

              <p
                style={{
                  textAlign: "center",
                  color: "#6b7280",
                }}
              >
                Loading team members...
              </p>

            )}


            {/* TEAM ERROR */}

            {!teamLoading && teamError && (

              <div
                style={{
                  textAlign: "center",
                  padding: "20px",
                }}
              >

                <p
                  style={{
                    color: "#dc2626",
                    marginBottom: "10px",
                  }}
                >
                  {teamError}
                </p>

                <button
                  type="button"
                  onClick={fetchTeam}
                  style={{
                    backgroundColor: "#0067B1",
                    color: "#ffffff",
                    border: "none",
                    padding: "8px 16px",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Try Again
                </button>

              </div>

            )}


            {/* NO TEAM */}

            {!teamLoading &&
              !teamError &&
              teamLeaders.length === 0 && (

                <p
                  style={{
                    textAlign: "center",
                    color: "#6b7280",
                  }}
                >
                  No team members found.
                </p>

              )}


            {/* TEAM DATA */}

            {!teamLoading &&
              !teamError &&
              teamLeaders.length > 0 && (

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: "2rem",
                  }}
                >

                  {teamLeaders.map(
                    (leader, index) => {

                      const isHovered =
                        hoveredLeader === index;

                      return (

                        <div
                          key={
                            leader.id ||
                            index
                          }
                          onMouseEnter={() =>
                            setHoveredLeader(
                              index
                            )
                          }
                          onMouseLeave={() =>
                            setHoveredLeader(
                              null
                            )
                          }
                          style={{
                            backgroundColor:
                              "#ffffff",
                            border:
                              "1px solid #f3f4f6",
                            borderRadius:
                              "0.75rem",
                            boxShadow:
                              isHovered
                                ? "0 10px 15px -3px rgba(0,0,0,0.1)"
                                : "0 1px 2px rgba(0,0,0,0.05)",
                            transition:
                              "all 0.2s ease",
                            display: "flex",
                            flexDirection:
                              "column",
                            alignItems:
                              "center",
                            padding:
                              "1.5rem",
                            textAlign:
                              "center",
                          }}
                        >

                          {/* PROFILE IMAGE */}

                          <div
                            style={{
                              width: "8rem",
                              height: "8rem",
                              borderRadius:
                                "9999px",
                              overflow:
                                "hidden",
                              marginBottom:
                                "1.25rem",
                              border:
                                "4px solid rgba(255,213,0,0.5)",
                              backgroundColor:
                                "#f0f7ff",
                              display:
                                "flex",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                            }}
                          >

                            {leader.profile_image ? (

                              <img
                                src={
                                  leader.profile_image
                                }
                                alt={
                                  leader.name
                                }
                                style={{
                                  width:
                                    "100%",
                                  height:
                                    "100%",
                                  objectFit:
                                    "cover",
                                }}
                                onError={(
                                  e
                                ) => {
                                  e.currentTarget.style.display =
                                    "none";
                                }}
                              />

                            ) : (

                              <span
                                style={{
                                  fontSize:
                                    "2.5rem",
                                }}
                              >
                                👤
                              </span>

                            )}

                          </div>


                          {/* NAME */}

                          <h3
                            style={{
                              fontSize:
                                "1.25rem",
                              fontWeight:
                                "700",
                              color:
                                "#0067B1",
                              marginBottom:
                                "0.25rem",
                            }}
                          >
                            {
                              leader.name
                            }
                          </h3>


                          {/* DESIGNATION */}

                          <p
                            style={{
                              color:
                                "#6b7280",
                              fontSize:
                                "0.75rem",
                              fontWeight:
                                "600",
                              letterSpacing:
                                "0.05em",
                              textTransform:
                                "uppercase",
                            }}
                          >
                            {
                              leader.designation
                            }
                          </p>

                        </div>

                      );
                    }
                  )}

                </div>

              )}

          </div>
        </section>


        {/* ==================================================
                    INTERNATIONAL PROGRAMS
                ================================================== */}

        <section
          style={{
            padding: "4rem 0",
            backgroundColor: "#ffffff",
          }}
        >

          <div style={containerStyle}>

            <div
              style={{
                textAlign: "center",
                marginBottom: "3rem",
              }}
            >

              <span style={spanBadgeStyle}>
                Programs & Initiatives
              </span>

              <h2
                style={{
                  fontSize: "1.875rem",
                  fontWeight: "800",
                  color: "#0067B1",
                  marginTop: "1.25rem",
                }}
              >
                International Programs in MD 320
              </h2>

            </div>


            {/* PROGRAM LOADING */}

            {programsLoading && (

              <p
                style={{
                  textAlign: "center",
                  color: "#6b7280",
                }}
              >
                Loading programs...
              </p>

            )}


            {/* PROGRAM ERROR */}

            {!programsLoading &&
              programsError && (

                <div
                  style={{
                    textAlign: "center",
                    padding: "20px",
                  }}
                >

                  <p
                    style={{
                      color: "#dc2626",
                      marginBottom: "10px",
                    }}
                  >
                    {programsError}
                  </p>

                  <button
                    type="button"
                    onClick={fetchPrograms}
                    style={{
                      backgroundColor:
                        "#0067B1",
                      color: "#ffffff",
                      border: "none",
                      padding:
                        "8px 16px",
                      borderRadius:
                        "5px",
                      cursor: "pointer",
                    }}
                  >
                    Try Again
                  </button>

                </div>

              )}


            {/* NO PROGRAMS */}

            {!programsLoading &&
              !programsError &&
              programs.length === 0 && (

                <p
                  style={{
                    textAlign: "center",
                    color: "#6b7280",
                  }}
                >
                  No international programs
                  found.
                </p>

              )}


            {/* PROGRAM DATA */}

            {!programsLoading &&
              !programsError &&
              programs.length > 0 && (

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(auto-fit, minmax(300px, 1fr))",
                    gap: "1.5rem",
                  }}
                >

                  {programs.map(
                    (program, index) => {

                      const isHovered =
                        hoveredCard === index;

                      return (

                        <div
                          key={
                            program.id ||
                            index
                          }
                          onMouseEnter={() =>
                            setHoveredCard(
                              index
                            )
                          }
                          onMouseLeave={() =>
                            setHoveredCard(
                              null
                            )
                          }
                          style={{
                            backgroundColor:
                              "#ffffff",
                            borderRadius:
                              "0.75rem",
                            padding:
                              "1.75rem",
                            border:
                              isHovered
                                ? "1px solid #0067B1"
                                : "1px solid #f3f4f6",
                            boxShadow:
                              isHovered
                                ? "0 4px 6px -1px rgba(0,0,0,0.1)"
                                : "none",
                            transition:
                              "all 0.2s ease",
                          }}
                        >

                          <div
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "flex-start",
                              justifyContent:
                                "space-between",
                              marginBottom:
                                "1rem",
                            }}
                          >

                            {/* ICON */}

                            <span
                              style={{
                                fontSize:
                                  "1.875rem",
                              }}
                            >
                              {program.icon ||
                                "🌍"}
                            </span>


                            {/* CATEGORY */}

                            <span
                              style={{
                                fontSize:
                                  "0.625rem",
                                fontWeight:
                                  "700",
                                letterSpacing:
                                  "0.1em",
                                textTransform:
                                  "uppercase",
                                color:
                                  "#0067B1",
                                backgroundColor:
                                  "#f0f7ff",
                                padding:
                                  "0.25rem 0.625rem",
                                borderRadius:
                                  "9999px",
                              }}
                            >
                              {
                                program.service_activity
                              }
                            </span>

                          </div>


                          {/* TITLE */}

                          <h3
                            style={{
                              fontWeight:
                                "700",
                              fontSize:
                                "1.125rem",
                              color:
                                isHovered
                                  ? "#0067B1"
                                  : "#111827",
                              marginBottom:
                                "0.5rem",
                              transition:
                                "color 0.2s ease",
                            }}
                          >
                            {
                              program.title
                            }
                          </h3>


                          {/* DESCRIPTION */}

                          <p
                            style={{
                              color:
                                "#6b7280",
                              fontSize:
                                "0.875rem",
                              lineHeight:
                                "1.6",
                            }}
                          >
                            {
                              program.description
                            }
                          </p>

                        </div>

                      );
                    }
                  )}

                </div>

              )}

          </div>
        </section>


        {/* ==================================================
                    CTA
                ================================================== */}

        <section
          style={{
            padding: "3.5rem 0",
            backgroundColor: "#0067B1",
            textAlign: "center",
          }}
        >

          <div style={containerStyle}>

            <h2
              style={{
                fontSize: "1.5rem",
                fontWeight: "800",
                color: "#ffffff",
                marginBottom: "1rem",
              }}
            >
              Explore MD 320 Districts
            </h2>

            <p
              style={{
                color: "rgba(255,255,255,0.7)",
                marginBottom: "1.75rem",
                maxWidth: "32rem",
                marginInline: "auto",
                fontSize: "0.875rem",
              }}
            >
              Discover how our eight districts implement
              these international programs locally.
            </p>

            <Link
              to="/multiple-districts"
              onMouseEnter={() =>
                setIsCtaHovered(true)
              }
              onMouseLeave={() =>
                setIsCtaHovered(false)
              }
              style={{
                backgroundColor:
                  isCtaHovered
                    ? "#f0c800"
                    : "#FFD500",
                color: "#0067B1",
                fontWeight: "700",
                padding:
                  "0.75rem 1.75rem",
                borderRadius:
                  "0.375rem",
                textDecoration:
                  "none",
                display:
                  "inline-block",
              }}
            >
              View All Districts
            </Link>

          </div>

        </section>

      </div>

      <Footer />
    </>
  );
}
